import classNames from 'classnames';

import { CustomerOrderDto } from 'common/api/autogenerated/trading-gateway';

import { Button, SvgIconUrl } from 'common/components';

import { useBowser, useI18n } from 'common/hooks';
import { ModalAction } from 'common/redux/modal/initialState';
import svgIcons from 'common/svgIcons';

import { Order } from 'components/Orders/list/Order.component';

import './index.css';

export interface CancelOrderProps extends ModalAction {
  order: CustomerOrderDto;
  onConfirm: () => void;
  onCancel: () => void;
}

const CancelOrderPopup = ({ order, onConfirm, onCancel }: CancelOrderProps) => {
  const { translate } = useI18n();
  const { isDesktop, isMobile } = useBowser();

  const onCancelOrder = () => {
    onConfirm();
    onCancel();
  };
  const onClose = () => onCancel();

  const titleClassNames = classNames({
    'cancel-order__title': true,
    T2_med_32: isDesktop,
    H1_med_20: isMobile,
  });

  return (
    <div className='cancel-order'>
      <div className='cancel-order__icon'>
        <SvgIconUrl className='cancel-order__svg' symbol={svgIcons.ExclamationMark()} />
      </div>
      <h1 className={titleClassNames}>{translate.toText('mobile:order:cancel-popup:title')}</h1>
      <Order {...order} isColumn isRow={false} disableRedirect />
      <div className='cancel-order__buttons'>
        <Button data-test='spot-delete-order-cancel' large stretch outline onClick={onClose}>
          {translate.toText('mobile:order:cancel-popup:back')}
        </Button>
        <Button data-test='spot-delete-order-confirm' large stretch className='button--red' onClick={onCancelOrder}>
          {translate.toText('mobile:order:cancel-popup:submit')}
        </Button>
      </div>
    </div>
  );
};

const config: ModalAction = {
  hideCloseIcon: true,
  animation: 'appearUp',
  wrapperClassName: 'cancel-order-popup',
};

export default (props: CancelOrderProps) => ({
  component: <CancelOrderPopup {...props} />,
  ...config,
  ...props,
});
